import {GetStaticPropsResult} from "next"
import {DrupalNode} from "next-drupal"

import {drupal} from "lib/drupal"
import {Layout} from "components/layout"
import {NodeAnnonceLegaleTeaser} from "@/components/nodeTypes";

import {Separator} from "@/components/ui/separator";
import PaginationList from "@/components/pagination/PaginationList";
import {DrupalJsonApiParams} from "drupal-jsonapi-params";
import Container from "@/components/ui/container";
import Breadcrumbs from "@/components/breadcrumb";
import {HeadMetadata} from "@/components/headMetadata";
import React from "react";

interface AnnonceLegalesPageProps {
  nodes: DrupalNode[],
  limit: number,
  count: number,
  contextQuery: Object
}
export default function AnnonceLegalesPage({nodes, limit, count, contextQuery} : AnnonceLegalesPageProps) {

  const resources = drupal.deserialize(nodes) as DrupalNode[];
  const breadcrumb = [
    {label: 'Annonces légales' }
  ];

  return (
    <Layout>
      <HeadMetadata
        title="Annonces légales"
        description="Bienvenue sur notre page dédiée aux annonces légales. RRB est un média habilité par l’Etat à diffuser les annonces judiciaires et légales."
      />

      <Container className="py-10">
        <div>
          <Breadcrumbs entries={breadcrumb} />

          <h1 className="mb-2 text-[40px] text-foreground-dark">Annonces légales</h1>

          <p className='text-foreground-light mb-3'>Bienvenue sur notre page dédiée aux annonces légales. RRB est un média habilité par l’Etat à diffuser les annonces judiciaires et légales. Pour faire paraître vos annonces ou obtenir un devis, veuillez nous contacter à annonceslegales@rrb.nc</p>

          <Separator className='mb-4'/>

          <div className="py-8 flex flex-col gap-4 max-w-[565px] mx-auto">
            {resources?.length ? (
              resources
                .map((node) => (
                  <div key={node.id}>
                    <NodeAnnonceLegaleTeaser node={node}/>
                  </div>
                ))
            ) : (
              <p className="py-4">Aucune annonce légale</p>
            )}

          </div>

          <PaginationList count={count} limit={limit} contextQuery={contextQuery}/>

        </div>
      </Container>
    </Layout>
  )
}

export async function getServerSideProps(context): Promise<GetStaticPropsResult<AnnonceLegalesPageProps>> {
  context.res.setHeader(
    'Cache-Control',
    'public, s-maxage=60, stale-while-revalidate=0, max-age=60'
  )

  // Récupération des query params
  const contextQuery = context.query || {};
  const page = contextQuery.page || 1;

  // A modifier si besoin
  const limit = 6;
  const offset = (page - 1) * limit;

  const params = new DrupalJsonApiParams()
    .addFields("node--annonce_legale", ["title", "path", "field_image", "body", "uid", "created"])
    .addFilter("status", "1")
    .addInclude(["field_image", "uid"])
    .addSort("created", "DESC")
    .addPageLimit(limit)
    .addPageOffset(offset)

  const nodes = await drupal.getResourceCollectionFromContext<DrupalNode[]>(
    "node--annonce_legale",
    context,
    {
      params: params.getQueryObject(),
      deserialize: false,
    }
  )

  // @ts-ignore
  const count = nodes.meta.count || 0;

  return {
    props: {
      nodes,
      limit,
      count,
      contextQuery
    },
  }
}
